/* eslint-disable */

import ep from './endpoints';
import Cookies from 'js-cookie';
import qs from 'qs';

function urlBuilder() {
    if (this.params) {
        // https://stackoverflow.com/questions/1144783/how-to-replace-all-occurrences-of-a-string
        return Object.keys(this.params)
            .reduce((url, key) =>
                url.split(`:${key}`).join(this.params[key]),
                    this.url
        );
        // return Object.keys(this.params)
        //     .reduce((url, key) =>
        //         url.replace(`:${key}`, this.params[key]),
        //             this.url
        // );
        // return Object.keys(this.params)
        //     .reduce((url, key) =>
        //         url.replace(new RegExp(`:${key}`, 'g'), this.params[key]),
        //             this.url
        // );
    }
    return this.url;
}

function caller(app) {
    return async function api(...args) {
        const [name, method] = this.split('.');
        let context = Object.assign({}, ep[name][method]);
        ['data', 'params', 'query', 'opt'].forEach(v => {
            if (v === 'opt' && typeof args[0].opt !== 'undefined') {
                context = {...context, ...args[0].opt};
            } else if (v !== 'opt') {
                context[v] = args[0][v] || null;
            }
        });
        context.url = urlBuilder.call(context);
        context.params = context.query;

        // handle nested params
        context.paramsSerializer = function (params) {
            return qs.stringify(params, {
                encodeValuesOnly: true,
                indices: false,
                arrayFormat: 'brackets'
            });
        };

        return ajax.apply(app, [context, ep]);
        // return require(`./${name}`).default[method]
        //     .apply(app, [context, ep]);
    };
}

async function ajax(context) {
    try {
        const response = await this.$axios(context);
        return response.data;

        // use this code if wanna use default headers
        // const tempContext = context;
        // let hasHeaders = typeof tempContext.headers !== 'undefined';
        // if (hasHeaders && typeof tempContext.headers['x-api-version'] === 'undefined') {
        //     hasHeaders = false;
        // }

        // // add default headers
        // if (!hasHeaders) {
        //     tempContext.headers = {
        //         'x-api-version': 2
        //     };
        // }

        // const response = await this.$axios(tempContext);
        // return response.data;
    } catch (error) {
        // handle JWT expired - error.errorCode === 'QUS-AUTH-008'
        if (error.errorCode === 'QUS-AUTH-008') {
            if (Cookies.get('r')) {
                try {
                    await this.store.dispatch('auth/authRefresh', {
                        data: {
                            refresh: Cookies.get('r')
                        }
                    });
                } catch (error) {
                    this.store.dispatch('auth/authDestroy');
                }

                // make sure error message is 'jwt expired'
                // so the error won't be shown by CSnackbar
                if (error.message !== 'jwt expired') {
                    error.message = 'jwt expired';
                }

                // trigger route-view key changing
                // so router.push same route make the page 're-mounted'
                this.store.dispatch('app/triggerRouteViewKey', {
                    trigger: true
                });

                // re-launch the previous axios action
                // ajax.apply(this, [context, ep]);
            } else {
                this.store.dispatch('auth/authDestroy');
            }
        }

        throw error;        
    }
}

export default ({ app }, inject) => {
    inject('api', caller(app));
};
